import { render, staticRenderFns } from "./PromotionArchiveConfirmationModal.vue?vue&type=template&id=e349a49e&scoped=true"
import script from "./PromotionArchiveConfirmationModal.vue?vue&type=script&lang=js"
export * from "./PromotionArchiveConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e349a49e",
  null
  
)

export default component.exports